/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';

type ConditionalTooltipArgs = {
  condition?: boolean;

  content?: string;
  direction?: string;
  contextual?: boolean;
  truncate?: boolean;

  tooltipClassNames?: string;
  triggerClassNames?: string;
};

export default class ConditionalTooltip extends Component<ConditionalTooltipArgs> {
  get direction() {
    return this.args.direction ?? 'bottom';
  }

  get contextual() {
    return this.args.contextual ?? false;
  }

  get truncate() {
    return this.args.truncate ?? false;
  }
}
